import axios from 'axios' 
import { BUSCAR_AGRUPADO_DISPONIBILIDADES_VEICULO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarAgrupadoDisponibilidadeVeiculoPorVeiculo (empresaId, veiculoId) {

  let url = `${URL}/disponibilidade-veiculo/empresa/${empresaId}/veiculo/${veiculoId}/agrupado-disponibilidade-veiculo`;

  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_AGRUPADO_DISPONIBILIDADES_VEICULO,
        payload: response

      })
  );
}
